import React from 'react'
import LoginForm from '../../Component/LoginPage/LoginForm'
import { AuthLayout } from '../../Component/LoginPage/AuthLayout'

const Login = () => {
  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  )
}

export default Login